"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TitleContent = exports.TitleContainer = exports.Title = exports.OpenIconFillOut = exports.OpenIcon = exports.ItemFillOut = exports.Item = exports.IconFillOut = exports.Icon = exports.HeadFillOut = exports.Head = exports.BodyFillOut = exports.Body = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.976 3.976a.976.976 0 0 0-1.952 0v9.048H3.976a.976.976 0 1 0 0 1.952h9.048v9.048a.976.976 0 1 0 1.953 0v-9.048h9.047a.976.976 0 0 0 0-1.952h-9.048V3.976z"
  }));
};
PlusIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.608 10.258a.952.952 0 0 0-1.351.047.964.964 0 0 0 .047 1.358l7.544 7.079a.952.952 0 0 0 1.304 0l7.544-7.079a.964.964 0 0 0 .047-1.358.952.952 0 0 0-1.35-.047L14.5 16.725l-6.892-6.467z"
  }));
};
ArrowDown.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var BORDER_RADIUS = '14px';
var BORDER_SIZE = '2px';
var Wrapper = exports.Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Wrapper",
  componentId: "sc-6md5od-0"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.inline['3xs']
  };
});
var Item = exports.Item = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Item",
  componentId: "sc-6md5od-1"
})(function (_ref2) {
  var color = _ref2.theme.color,
    open = _ref2.open;
  return {
    transition: '0.3s border',
    borderBottom: '1px solid',
    borderBottomColor: open ? color.brandPrimary.light : color.neutral['04']
  };
});
var ItemFillOut = exports.ItemFillOut = (0, _styledComponents["default"])(Item).withConfig({
  displayName: "Accordionstyle__ItemFillOut",
  componentId: "sc-6md5od-2"
})(function (_ref3) {
  var color = _ref3.theme.color,
    open = _ref3.open,
    _ref3$backgroundWhenO = _ref3.backgroundWhenOpen,
    backgroundWhenOpen = _ref3$backgroundWhenO === void 0 ? color.background.light : _ref3$backgroundWhenO;
  return {
    border: "".concat(BORDER_SIZE, " solid ").concat(open ? color.brandPrimary.light : 'transparent'),
    backgroundColor: open ? backgroundWhenOpen : color.brandPrimary.light,
    borderRadius: BORDER_RADIUS
  };
});
var Head = exports.Head = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Head",
  componentId: "sc-6md5od-3"
})(function (_ref4) {
  var _ref4$theme = _ref4.theme,
    color = _ref4$theme.color,
    spacing = _ref4$theme.spacing,
    open = _ref4.open;
  return {
    transition: '0.3s color',
    cursor: 'pointer',
    padding: "".concat(spacing.inline['3xs'], " 0"),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: open ? color.brandPrimary.light : color.neutral['02'],
    ':hover, :active': {
      color: color.brandPrimary.light
    }
  };
});
var HeadFillOut = exports.HeadFillOut = (0, _styledComponents["default"])(Head).withConfig({
  displayName: "Accordionstyle__HeadFillOut",
  componentId: "sc-6md5od-4"
})(function (_ref5) {
  var _ref5$theme = _ref5.theme,
    color = _ref5$theme.color,
    spacing = _ref5$theme.spacing,
    open = _ref5.open;
  return {
    position: 'relative',
    boxSizing: 'border-box',
    transition: '0.3s color, 0.3s background',
    padding: spacing.inline['3xs'],
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateRows: 'auto',
    gridTemplateAreas: open ? '"title title title" "leftIcon . rightIcon"' : '"leftIcon title rightIcon"',
    alignItems: 'center',
    minWidth: '100%',
    minHeight: '56px',
    color: open ? color.brandPrimary.light : color.neutral['07'],
    borderRadius: BORDER_RADIUS,
    ':hover, :active': {
      color: open ? color.brandPrimary.medium : color.neutral['05']
    }
  };
});
var Icon = exports.Icon = _styledComponents["default"].span.withConfig({
  displayName: "Accordionstyle__Icon",
  componentId: "sc-6md5od-5"
})(function (_ref6) {
  var _ref6$theme = _ref6.theme,
    color = _ref6$theme.color,
    spacing = _ref6$theme.spacing;
  return {
    fill: color.brandPrimary.light,
    marginRight: spacing.inline['3xs'],
    width: spacing.inline.xs,
    height: spacing.inline.xs,
    flex: "0 0 ".concat(spacing.inline.xs)
  };
});
var IconFillOut = exports.IconFillOut = (0, _styledComponents["default"])(Icon).withConfig({
  displayName: "Accordionstyle__IconFillOut",
  componentId: "sc-6md5od-6"
})(function (_ref7) {
  var color = _ref7.theme.color,
    open = _ref7.open;
  return {
    fill: open ? color.brandPrimary.light : color.neutral['07'],
    gridArea: 'leftIcon'
  };
});
var Title = exports.Title = _styledComponents["default"].p.withConfig({
  displayName: "Accordionstyle__Title",
  componentId: "sc-6md5od-7"
})(function (_ref8) {
  var theme = _ref8.theme;
  return _objectSpread(_objectSpread({}, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-md',
    margin: false
  })), {}, {
    flex: 'auto',
    margin: 0
  });
});
var TitleContainer = exports.TitleContainer = _styledComponents["default"].p.withConfig({
  displayName: "Accordionstyle__TitleContainer",
  componentId: "sc-6md5od-8"
})(function (_ref9) {
  var theme = _ref9.theme,
    open = _ref9.open,
    _ref9$backgroundWhenO = _ref9.backgroundWhenOpen,
    backgroundWhenOpen = _ref9$backgroundWhenO === void 0 ? theme.color.background.light : _ref9$backgroundWhenO;
  return _objectSpread(_objectSpread({}, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-md',
    margin: false
  })), {}, {
    flex: 'auto',
    margin: 0,
    gridArea: 'title',
    color: open ? theme.color.brandPrimary.light : theme.color.neutral['07'],
    ':before': {
      content: open ? '""' : '',
      position: 'absolute',
      top: "calc(".concat(BORDER_SIZE, " * -1)"),
      left: "calc(".concat(BORDER_SIZE, " * -1)"),
      right: "calc(".concat(BORDER_SIZE, " * -1)"),
      bottom: '80%',
      backgroundColor: backgroundWhenOpen
    },
    ':after': {
      content: open ? '""' : '',
      position: 'absolute',
      top: "calc(5% - ".concat(BORDER_SIZE, ")"),
      left: "calc(".concat(BORDER_SIZE, " * -1)"),
      right: "calc(".concat(BORDER_SIZE, " * -1)"),
      bottom: 0,
      border: "".concat(BORDER_SIZE, " solid ").concat(theme.color.brandPrimary.light),
      borderBottom: 'none',
      borderTopLeftRadius: BORDER_RADIUS,
      borderTopRightRadius: BORDER_RADIUS
    }
  });
});
var TitleContent = exports.TitleContent = _styledComponents["default"].span.withConfig({
  displayName: "Accordionstyle__TitleContent",
  componentId: "sc-6md5od-9"
})(function (_ref10) {
  var color = _ref10.theme.color,
    open = _ref10.open,
    _ref10$backgroundWhen = _ref10.backgroundWhenOpen,
    backgroundWhenOpen = _ref10$backgroundWhen === void 0 ? color.background.light : _ref10$backgroundWhen;
  return {
    position: open ? 'absolute' : 'initial',
    top: 'calc(-20%)',
    backgroundColor: open ? backgroundWhenOpen : 'initial',
    padding: open ? '0 4px' : 'initial',
    marginBottom: open ? '4px' : 'initial',
    zIndex: 1
  };
});
var OpenIcon = exports.OpenIcon = (0, _styledComponents["default"])(PlusIcon).withConfig({
  displayName: "Accordionstyle__OpenIcon",
  componentId: "sc-6md5od-10"
})(function (_ref11) {
  var spacing = _ref11.theme.spacing,
    open = _ref11.open;
  return {
    transition: '0.3s transform',
    flex: '0 0 18px',
    width: 18,
    marginLeft: spacing.inline['4xs'],
    transform: "rotateZ(".concat(open ? '45deg' : '0deg', ")")
  };
});
var OpenIconFillOut = exports.OpenIconFillOut = (0, _styledComponents["default"])(ArrowDown).withConfig({
  displayName: "Accordionstyle__OpenIconFillOut",
  componentId: "sc-6md5od-11"
})(function (_ref12) {
  var spacing = _ref12.theme.spacing,
    open = _ref12.open;
  return {
    transition: '0.3s transform',
    flex: '0 0 24px',
    width: 24,
    marginRight: spacing.inline['4xs'],
    gridArea: 'rightIcon',
    transform: "rotateZ(".concat(open ? '180deg' : '0deg', ")"),
    zIndex: 2
  };
});
var Body = exports.Body = _styledComponents["default"].div.withConfig({
  displayName: "Accordionstyle__Body",
  componentId: "sc-6md5od-12"
})(function (_ref13) {
  var spacing = _ref13.theme.spacing,
    height = _ref13.height;
  return {
    transition: '0.4s height',
    padding: '0',
    height: height,
    overflow: 'hidden',
    ':after': {
      content: '""',
      height: spacing.inline['3xs'],
      display: 'block'
    }
  };
});
var BodyFillOut = exports.BodyFillOut = (0, _styledComponents["default"])(Body).withConfig({
  displayName: "Accordionstyle__BodyFillOut",
  componentId: "sc-6md5od-13"
})(function (_ref14) {
  var spacing = _ref14.theme.spacing,
    open = _ref14.open;
  return {
    padding: "0 ".concat(spacing.inline['3xs']),
    opacity: open ? 1 : 0
  };
});